import { render } from "./LineChart.vue?vue&type=template&id=1947c1de&scoped=true"
import script from "./LineChart.vue?vue&type=script&lang=ts"
export * from "./LineChart.vue?vue&type=script&lang=ts"

import "./LineChart.vue?vue&type=style&index=0&id=1947c1de&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1947c1de"

export default script